(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter-grid"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-checkbox input[type="checkbox"]').forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        this.parentElement.classList.add('active');
      } else {
        this.parentElement.classList.remove('active');
      }
    });
  });
});
// FC Shaker collection ko properly handle karne ke liye updated code
$('.filter-color').on('change', 'input.color-filter', function () {
  const selectedValue = $(this).val().trim();
  const colorKeyword = selectedValue.toLowerCase();
  setTimeout(() => {
    $('.product-card').each(function () {
      const $item = $(this);
      const productDataEl = $item.find('script[type="application/json"]');
      if (!productDataEl.length) {
        console.log('❌ No JSON found for product card.');
        return;
      }
      try {
        const productData = JSON.parse(productDataEl.html());
        if (!productData.variants) return;
        const matchedVariant = productData.variants.find(v => (v.option2 && v.option2.toLowerCase().includes(colorKeyword)) || (v.title && v.title.toLowerCase().includes(colorKeyword)) );
        if (matchedVariant) {
          const $link = $item.find('a.getVariable');
          const baseUrl = $link.attr('href').split('?')[0];
          const newUrl = `${baseUrl}?variant=${matchedVariant.id}`;
          $link.attr('href', newUrl);
          console.log(`Matched variant for "${colorKeyword}" →`, newUrl);
        }
      } catch (error) {
        console.warn('Error parsing product JSON:', error);
      }
    });
  }, 1000);
});

function updateProductLinksByColor(selectedColor) {
  if (!selectedColor) {
    console.warn('No color selected');
    return;
  }
  const selectedValue = String(selectedColor).trim();
  if (!selectedValue) return;
  const colorKeyword = selectedValue.toLowerCase();
  $('.product-card').each(function () {
    const $item = $(this);
    const script = $item.find('script[type="application/json"]');
    if (!script.length) return;
    try {
      const productData = JSON.parse(script.html());
      const matchedVariant = productData.variants.find(v => (v.option2 && v.option2.toLowerCase().includes(colorKeyword)) || (v.title && v.title.toLowerCase().includes(colorKeyword)) );
      if (matchedVariant) {
        const $link = $item.find('a.getVariable');
        const baseUrl = $link.attr('href').split('?')[0];
        $link.attr('href', `${baseUrl}?variant=${matchedVariant.id}`);
      }
    } catch (err) {
      console.warn('Error parsing product JSON:', err);
    }
  });
}

function getSelectedColor() {
  const color = $('.filter-color input:checked').val() || '';
  return color.trim();
}

setInterval(() => {
  const selectedColor = getSelectedColor();
  if (selectedColor) {
    updateProductLinksByColor(selectedColor);
  }
}, 1000);

function addSampleDoorFromTitle(title) {
  const handle = title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') + '-sample-door';
  return fetch(`/products/${handle}.js`, {
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(res => {
    if (!res.ok) throw new Error(`Product not found: ${handle}`);
    return res.json();
  })
  .then(product => {
    if (!product.variants || !product.variants[0]) {
      throw new Error(`No variants found for: ${handle}`);
    }
    return product.variants[0].id;
  });
}

function addToCart(variantId, qty = 1) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  });
}

async function renderSideCart(cart) {
  if (!cart?.items?.length) return;
  const res = await fetch('/?section_id=cart-drawer', {
    headers: {
      Accept: 'text/html'
    }
  });
  if (!res.ok) {
    console.warn('cart-drawer fetch failed', res.status);
    return;
  }
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const newItems = doc.querySelector('#CartDrawer-CartItems');
  const newFooter = doc.querySelector('.cart-drawer__footer');
  document.querySelectorAll('cart-drawer.is-empty, .cart-drawer.is-empty, cart-drawer-items.is-empty')
    .forEach(el => el.classList.remove('is-empty'));
  const cartDrawer = document?.querySelector('cart-drawer-items');
  if (cartDrawer) cartDrawer.style.overflow = 'visible';
  document.querySelector('.drawer__inner-empty')?.remove();
  const currItems = document.querySelector('#CartDrawer-CartItems');
  const currFooter = document.querySelector('.cart-drawer__footer');
  if (newItems && currItems) currItems.innerHTML = newItems.innerHTML;
  if (newFooter && currFooter) currFooter.replaceWith(newFooter);
}

window.allProducts = [];
window.filteredProducts = [];

// =========================================================================
// COLLECTION HIDE LOGIC (System-Based) - FINAL ROBUST LOGIC
// =========================================================================
function hideCollectionCheckboxes() {
  // 1. General Configuration: Hamesha hide hone wali collections (24 names)
  const alwaysHideCollections = [
    'dover', 'california', 'petit', 'malibu', 'essex', 'fc shaker', 'mx recessed',
    'jar shaker', 'gramercy', 'trends', 'amesbury slab', 'jar pillow', 'yarmouth slab','mx shaker',
    'jar transitional', 'trenton recessed', 'venice', 'trenton slab', 'jar raised', 'signature',
    'amesbury recessed', 'weston', 'yarmouth raised', 'alvic', 'sample product'
  ];

  // 2. Collection-Specific Configuration: Kis page par kya hide karna hai
  // Nayi logic ke mutabiq, jahan tags SHOW karne hain, unhe hide list se nikal diya gaya hai.
  const collectionSpecificHides = {
    "dover": [
      'Base Cabinet Full Height Doors', 'Vanity Knee Drawer','Glass Doors','Valances','Corbels',
      'Touch Up Kit','Toe Kick Moldings','Tall Fillers','Soft Close Rollout Trays','Light Rail Moldings',
      'Turnposts','Cabinet Feet','Crown Moldings','End Panels','Misc. Moldings','Base Moldings',
      'Decorative Panels', 'Plywood Panels'
    ],
    "fc-shaker": [
      'Matrix','Touch Up Kit','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays'
    ],
    "california": [
      // 'Wall Cabinets with glass doors' aur 'Lasy Susans' ko hata diya gaya hai taake woh show hon
      'Base Full Height Doors', 'Vanity Knee Drawer','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point',
      'Oven Overlay Panel', 'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings',
      'Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic'
    ],
    "petit": [
      'Matrix','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Wood','No Mullion','Soft Close Rollout Trays'
    ],
    "malibu": [
      // 'Wall Cabinets with glass doors' aur 'Lasy Susans' ko hata diya gaya hai taake woh show hon
      'Base Full Height Doors','Vanity Knee Drawer', 'Glass Doors','North Point','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point',
      'Oven Overlay Panel', 'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings',
      'Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic','No Mullion','Soft Close Rollout Trays'
    ],
    "essex": [
      // 'Wall Cabinets with glass doors' ko hata diya gaya hai taake woh show ho
      'Base Cabinet Full Height Doors','Vanity Knee Drawer','Glass Doors','Soft Close Rollout Trays','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','No Mullion',
    ],
    "mx-recessed": [
      'Base Cabinet Full Height Doors','Vanity Knee Drawer','Plywood Panels','Decorative Panels','Base Fillers',
      'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers'
    ],
    "jar-shaker": [
      // 'Lasy Susans' aur 'Trash Pullout' pehle se is list mein nahi the, isliye woh show honge
      'Vanity Knee Drawer','Wall End Cabinets','Base Full Height Doors','Base Microwave Cabinets','Plywood Panels',
      'Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels',
      'Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Matrix','Wood Hoods'
    ],
    "gramercy": [
      'Base Cabinet Full Height Doors','Base Full Height Doors','Vanity Knee Drawer','Matrix','Plywood Panels',
      'Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels',
      'Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost'
    ],
    "amesbury-slab": [
      'Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts',
      'Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost'
    ],
    "jar-pillow": [
      // 'Lasy Susans' aur 'Trash Pullout' pehle se is list mein nahi the, isliye woh show honge
      'Base Cabinet Full Height Doors','Vanity Knee Drawer','Wall End Cabinets','Plywood Panels','Decorative Panels',
      'Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts','Corbels','Crown Moldings',
      'Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings','Overlay Fillers',
      'Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic',
      'Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Wood Hoods'
    ],
    "yarmouth-slab": [
      'Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts',
      'Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Cabinet Feet',
      'Vanity Cabinets'
    ],
    "mx-shaker": [
      'Matrix','Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels',
      'Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances',
      'Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit',
      'Wall Fillers', 'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers',
      'Turnpost','Cabinet Feet','Vanity Knee Drawer','Base Corner Cabinets'
    ],
    "jar-transitional": [
      // 'Lasy Susans' aur 'Trash Pullout' pehle se is list mein nahi the, isliye woh show honge
      'Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts',
      'Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Cabinet Feet','Wood Hoods'
    ],
    "trenton-recessed": [
      'Vanity Knee Drawer','Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings',
      'End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings',
      'Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix',
      'Fluted Fillers','Turnpost','Cabinet Feet','Glass Doors'
    ],
    "trenton-slab": [
      // 'Wall Cabinets with glass doors' ko hata diya gaya hai taake woh show ho
      'Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts',
      'Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Cabinet Feet',
      'Glass Doors'
    ],
    "jar-raised": [
      // 'Lasy Susans' aur 'Trash Pullout' pehle se is list mein nahi the, isliye woh show honge
      'Vanity Knee Drawer','Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings',
      'End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings',
      'Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix',
      'Fluted Fillers','Turnpost','Cabinet Feet','Wood Hoods'
    ],
    "signature": [
      'Matrix','Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels',
      'Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances',
      'Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit',
      'Wall Fillers', 'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers',
      'Turnpost','Cabinet Feet'
    ],
    "amesbury-recessed": [
      'Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings','End Panels','Turnposts',
      'Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel', 'Valances','Light Rail Moldings',
      'Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings','Touch Up Kit','Wall Fillers',
      'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix','Fluted Fillers','Turnpost','Cabinet Feet',
      'Glass Doors'
    ],
    "yarmouth-raised": [
      'Vanity Cabinets','Plywood Panels','Decorative Panels','Base Fillers', 'Base Moldings','Misc. Moldings',
      'End Panels','Turnposts','Corbels','Crown Moldings','Cabinet Foot','North Point','Oven Overlay Panel',
      'Valances','Light Rail Moldings','Overlay Fillers','Polished Chrome','Tall Fillers','Toe Kick Moldings',
      'Touch Up Kit','Wall Fillers', 'Wall Fillers','Plastic','Mullion','Soft Close Rollout Trays','Matrix',
      'Fluted Fillers','Turnpost','Cabinet Feet','Glass Doors'
    ],
    "alvic": [
      // 'Wall Deep Cabinets Single Lift Up Door' pehle se is list mein nahi tha, isliye woh show hoga
      'Plywood Panels','No Mullion','Toe Kick Moldings','Decorative Panels','Touch Up','Wood Hoods'
    ],
    "us-cabinet-depot": [
       "Plywood Panels",
    "Decorative Panels",
    "Base Fillers",
    "Base Moldings",
    "Misc. Moldings",
    "End Panels",
    "Turnposts",
    "Corbels",
    "Crown Moldings",
    "Cabinet Foot",
    "North Point",
    "Oven Overlay Panel",
    "Valances",
    "Light Rail Moldings",
    "Overlay Fillers",
    "Polished Chrome",
    "Tall Fillers",
    "Toe Kick Moldings",
    "Touch Up Kit",
    "Wall Fillers",
    "Plastic",
    "Mullion",
    "Soft Close Rollout Trays",
    "Fluted Fillers",
    "Turnpost",
    "Cabinet Feet",
    "Glass Doors",
    "Accessories",
    "Decorative Items",
    "Fillers",
    "Moldings",
    "Panels",
    "Rollout Trays",
    "Touch Up",
    "Wood Hoods"
    ]
  };

  // 3. Current Collection Handle (URL se nikalna)
  const path = window.location.pathname;
  const match = path.match(/\/collections\/([^\/?#]+)/);
  const currentHandle = match ? match[1] : null;

  // 4. Final list of terms to hide
  let termsToHide = [...alwaysHideCollections];

  // **ROBUST HANDLE CHECK:** Current collection handle ko target karna.
  const isFCShakerPage = currentHandle && (currentHandle.includes('fc-shaker') || currentHandle.includes('fcshaker'));
  const isGramercyPage = currentHandle && currentHandle.includes('gramercy'); // <-- GRAMERCY CHECK
  const isUSCabinetDepotPage = currentHandle && (currentHandle.includes('us-cabinet-depot') || currentHandle.includes('uscabinetdepot')); // <-- US CABINET DEPOT CHECK

  if (isFCShakerPage) {
    const fcShakerTerms = collectionSpecificHides['fc-shaker'];
    if (fcShakerTerms) {
      termsToHide = [...termsToHide, ...fcShakerTerms];
      console.log(`Applying **FC SHAKER** specific hide rules (Total extra hidden: ${fcShakerTerms.length})`);
    }
  } else if (isGramercyPage) { // <-- GRAMERCY CONDITION ADDED
    const gramercyTerms = collectionSpecificHides['gramercy'];
    if (gramercyTerms) {
      termsToHide = [...termsToHide, ...gramercyTerms];
      console.log(`Applying **GRAMERCY** specific hide rules (Total extra hidden: ${gramercyTerms.length})`);
    }
  } else if (isUSCabinetDepotPage) { // <-- US CABINET DEPOT CONDITION ADDED
    const usCabinetDepotTerms = collectionSpecificHides['us-cabinet-depot'];
    if (usCabinetDepotTerms) {
      termsToHide = [...termsToHide, ...usCabinetDepotTerms];
      console.log(`Applying **US CABINET DEPOT** specific hide rules (Total extra hidden: ${usCabinetDepotTerms.length})`);
    }
  } else if (currentHandle && collectionSpecificHides[currentHandle]) {
    termsToHide = [...termsToHide, ...collectionSpecificHides[currentHandle]];
    console.log(`Applying specific hide rules for collection: ${currentHandle}`);
  } else {
    console.log("Applying general hide rules.");
  }

  // 5. Regular expression to match the names (case-insensitive and robust)
  // Yeh regex spacing/hyphens/underscores ko ignore karega (e.g., "Touch Up Kit" matches "touch-up-kit" and "touch_up_kit")
  const regex = new RegExp(termsToHide.map(c => c.toLowerCase().trim().replace(/[-\s_]/g, '[-_\\s]?')
  ).join('|'), 'i'); // 'i' flag for case-insensitivity

  // --- Hiding Logic ---
  let hiddenCount = 0;
  // A) Sidebar filters (.coll_colors mein labels)
  const sidebarLabels = document.querySelectorAll('.coll_colors label.custom-checkbox');
  sidebarLabels.forEach(label => {
    const labelText = label.querySelector('.term-label')?.textContent?.toLowerCase().trim();
    if (labelText && regex.test(labelText)) {
      label.style.display = 'none';
      hiddenCount++;
    } else {
      label.style.display = '';
    }
  });

  // B) Top filter tabs (.filter-group.cabinets mein labels)
  const topFilterLabels = document.querySelectorAll('.filter-group.cabinets label');
  topFilterLabels.forEach(label => {
    const labelText = label.querySelector('.collection-title')?.textContent?.toLowerCase().trim();
    if (labelText && regex.test(labelText)) {
      label.style.display = 'none';
      hiddenCount++;
    } else {
      label.style.display = '';
    }
  });
  console.log(`Total elements hidden by filter logic: ${hiddenCount}`);
}
// =========================================================================
// END COLLECTION HIDE LOGIC
// =========================================================================

// **FUNCTION CALLING CONFIRMATION:**
// Yeh function ko multiple times call karwana zaroori hai.
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initial hide call');
  hideCollectionCheckboxes();
  // Dynamic content load hone ke liye double check
  setTimeout(hideCollectionCheckboxes, 500);
  setTimeout(hideCollectionCheckboxes, 1500);
});

// Types update hone pe bhi call karo
const originalUpdateTypes = window.updateTypes;
window.updateTypes = async function(types) {
  if (originalUpdateTypes) {
    await originalUpdateTypes(types);
  }
  console.log('Types updated - hiding collections');
  // Hide logic ko phir se chalao
  setTimeout(hideCollectionCheckboxes, 100);
  setTimeout(hideCollectionCheckboxes, 500);
};

document.addEventListener("DOMContentLoaded", async () => {
  const { uniqueTags, products } = await filterTags([]);
  window.allProducts = products;
  await updateTypes(uniqueTags);
  await updateProducts(products);
  const color = $('.filter-color input:checked').val();
  updateProductLinksByColor(color);
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fco_btn2.sample-door-button').forEach(button => {
    button.addEventListener('click', async (e) => {
      const titleElement = e.currentTarget.closest('.collection-box')?.querySelector('.collection-title');
      if (!titleElement) return;
      const btn = e.currentTarget;
      const originalText = btn.textContent;
      btn.disabled = true;
      try {
        const variantId = await addSampleDoorFromTitle(titleElement.textContent);
        await addToCart(variantId, 1);
        const cart = await fetch('/cart.js').then(res => res.json());
        await renderSideCart(cart);
        const icon = document.querySelector('.open-cart-drawer .fa-shopping-cart') || document.querySelector('.fa-shopping-cart');
        if (icon) {
          let badge = document.getElementById('cart-item-count');
          if (!badge) {
            badge = document.createElement('span');
            badge.id = 'cart-item-count';
            badge.className = 'totals__total-value';
            badge.style.display = 'inline-flex';
            icon.parentNode.insertBefore(badge, icon);
          }
          badge.textContent = String(cart.item_count);
        }
        const header = document.querySelector('.drawer__heading');
        if (header) {
          header.innerHTML = `Your cart <span class="totals__total-value" id="cart-item-count" style="display: inline-flex; align-items: center; justify-content: center; min-width: auto; height: auto; border-radius: 50%; background-color: #eec892; color: black; font-size: 16px; line-height: 1; margin-left: 8px; padding: 7px; font-weight: 900;">${cart.item_count}</span>`;
        }
        const drawer = document.querySelector('.drawer');
        if (!drawer) return;
        setTimeout(() => drawer.classList.add('active'), 500);
      } catch (err) {
        console.error(err);
        console.log(err.message || 'Error adding sample door to cart.');
      } finally {
        btn.disabled = false;
      }
    });
  });
});

// Top Tabs Filter
const tabs = Array.from(document.querySelectorAll('.filter-group.cabinets label'));
const inputs = Array.from(document.querySelectorAll('.filter-group.cabinets label input'));
const cards = Array.from(document.querySelectorAll('.product-grid .product-card'));
const noMsg = document.querySelector('.no_coll');
const slug = s => (s || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

// Default tags
const DEFAULT_TYPE_TAGS = [
  'Base Cabinet Full Height Doors','Base Cabinet with Doors & Drawers','Base Corner Cabinets',
  'Base Full Height Doors','Base Microwave Cabinets','Base Specialty Cabinets','Drawer Base Cabinets',
  'Sink Base Cabinets','Vanity Drawer Bases','Vanity Knee Drawer','Vanity Sink Bases',
  'Vanity Sink Bases with Doors and Drawers','Oven Cabinets','Pantry Cabinets',
  'Wall Cabinets Double Doors','Wall Cabinets Single Door','Wall Corner Cabinets','Wall Deep Cabinets',
  'Wall End Cabinets','Wall Specialty Cabinets','Wall Cabinets with Glass Doors','Wood Hoods','Decorative Items','Fillers','Glass Doors',
  'Moldings','Panels','Rollout Trays','Touch Up'
];

window.filterTags = async function(tags) {
  const selected = Array.isArray(tags) ? tags.map(String).map(s => s.trim()).filter(Boolean) : (tags ? [String(tags).trim()] : []);
  const selectedSet = new Set(selected.map(t => t.toLowerCase()));

  function currentProductsEndpoint() {
    const m = location.pathname.match(/^\/collections\/([^\/?#]+)/);
    const endpoint = m ? `/collections/${decodeURIComponent(m[1])}/products.json` : `/products.json`;
    return endpoint;
  }

  async function fetchAllProducts(endpointBase) {
    if (!endpointBase) throw new Error('fetchAllProducts called with empty endpointBase');
    const limit = 250;
    let page = 1;
    const all = [];
    while (true) {
      const url = `${endpointBase}${endpointBase.includes('?') ? '&' : '?'}limit=${limit}&page=${page}`;
      const res = await fetch(url, {
        headers: {
          Accept: 'application/json'
        }
      });
      if (!res.ok) throw new Error(`Fetch failed ${res.status}: ${await res.text()}`);
      const data = await res.json();
      const products = Array.isArray(data?.products) ? data.products : (Array.isArray(data) ? data : []);
      if (!products.length) break;
      all.push(...products);
      if (products.length < limit) break;
      page += 1;
    }
    return all;
  }

  const getTags = (p) => {
    if (Array.isArray(p.tags)) return p.tags;
    if (typeof p.tags === 'string') return p.tags.split(',').map(s => s.trim()).filter(Boolean);
    return [];
  };

  if (selected.length === 0) {
    const all = await fetchAllProducts(currentProductsEndpoint());
    return {
      uniqueTags: [...DEFAULT_TYPE_TAGS],
      products: all
    };
  }

  const all = await fetchAllProducts(currentProductsEndpoint());
  const matched = all.filter(p => {
    const t = getTags(p).map(x => x.toLowerCase());
    return t.some(x => selectedSet.has(x));
  });

  const seen = new Set();
  const uniqueTags = [];
  for (const p of matched) {
    for (const t of getTags(p)) {
      const k = t.toLowerCase();
      if (!seen.has(k) && t !== '' && !selectedSet.has(k)) {
        seen.add(k);
        uniqueTags.push(t);
      }
    }
  }

  const finalTags = uniqueTags.length === 0 ? [...DEFAULT_TYPE_TAGS] : uniqueTags;

  // Hiding function call (after filter)
  setTimeout(hideCollectionCheckboxes, 300);

  return {
    uniqueTags: finalTags,
    products: matched
  };
}

function applyFilter(selectedTags = []) {
  const sel = new Set(selectedTags.map(slug));
  let visible = 0;

  cards.forEach(card => {
    const cardTags = (card.dataset.tags || '')
      .split(',')
      .map(t => slug(t.trim()))
      .filter(Boolean);
    const show = sel.size === 0 || cardTags.some(t => sel.has(t));
    card.classList.toggle('is-hidden', !show);
    if (show) visible++;
  });

  const oldMsg = document.querySelector('.no_coll');
  if (oldMsg) oldMsg.remove();

  if (visible === 0) {
    const msg = document.createElement('p');
    msg.className = 'no_coll';
    msg.textContent = 'No products match your filters.';
    document.querySelector('.product-grid')?.appendChild(msg);
  }

  // Hiding function call (after filter)
  setTimeout(hideCollectionCheckboxes, 300);
}

const tabLabel = (labelEl) => labelEl.querySelector('.collection-title')?.textContent.trim() || '';

window.selectedTabTexts = function() {
  return inputs
    .filter(i => i.checked)
    .map(i => tabLabel(i.closest('label')))
    .filter(Boolean);
}

tabs.forEach(label => {
  label.addEventListener('click', async (e) => {
    e.preventDefault();
    const input = label.querySelector('input');
    if (!input) return;

    input.checked = !input.checked;
    label.classList.toggle('active', input.checked);

    const { uniqueTags, products } = await filterTags(selectedTabTexts());
    await updateTypes(uniqueTags);
    window.allProducts = products;
    await updateProducts(products);

    // Hiding function call (after filter)
    setTimeout(hideCollectionCheckboxes, 300);
  });
});

inputs.forEach(input => {
  input.addEventListener('click', (e) => {
    e.preventDefault();
    e.target.toggleAttribute('checked', e.target.checked);
    const label = input.closest('label');
    if (label) label.classList.toggle('active', e.target.checked);

    applyFilter(selectedTabTexts());
  });
});

inputs.forEach(i => i.closest('label')?.classList.toggle('active', i.checked));
applyFilter([]);

// Setup
const norm = s => (s ?? '').toString().trim().toLowerCase();
const colorSelectSelector = 'select[name="modal_option_0"], select#option-0, select[name="modal_option_1"], select#option-1';

function getSelectedColor() {
  const checked = document.querySelector('.color-filter[type="checkbox"]:checked');
  return checked?.value?.trim() || checked?.closest('label')?.querySelector('.collection-title')?.textContent.trim() || '';
}

function minPrice(prices){
  if (!Array.isArray(prices) || prices.length === 0) return 0;
  return Math.min(...prices);
}

window.currentPage = 1;
const perPage = 12;

window.updateProducts = async function(products) {
  const container = document.querySelector('.product-grid');
  container.innerHTML = '';

  if (!products || !products.length) {
    const msg = document.createElement('p');
    msg.className = 'no_coll';
    msg.textContent = 'No products match your filters.';
    container.appendChild(msg);
    return;
  }

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const start = (window.currentPage - 1) * perPage;
  const end = start + perPage;
  const paginatedProducts = products.slice(start, end);

  paginatedProducts.forEach((product) => {
    const card = document.createElement('div');
    card.className = 'product-card';
    card.setAttribute('data-tags', product.tags.join(','));
    card.setAttribute('data-type', product.type);
    card.setAttribute('data-color-pattern', '');

    const imgDiv = document.createElement('div');
    imgDiv.className = 'c-wc-product-collection__img';
    const img = document.createElement('img');
    if (product.images && product.images.length > 0 && product.images[0].src) {
      img.src = product.images[0].src;
    } else {
      img.src = 'https://via.placeholder.com/300x300?text=No+Image';
    }
    img.alt = product.title || 'Product Image';
    imgDiv.appendChild(img);
    card.appendChild(imgDiv);

    const detailsDiv = document.createElement('div');
    detailsDiv.className = 'c-wc-product-collection__main';
    const title = document.createElement('h3');
    title.className = 'c-wc-product-collection__title';
    const anchor = document.createElement('a');
    anchor.className = 'getVariable';
    anchor.href = '/products/' + product.handle;
    anchor.textContent = product.title;
    anchor.target = '_blank';
    title.appendChild(anchor);
    detailsDiv.appendChild(title);

    const productDataScript = document.createElement('script');
    productDataScript.type = 'application/json';
    productDataScript.textContent = JSON.stringify(product);
    card.appendChild(productDataScript);


    const popupView = document.createElement('div');
    popupView.className = 'popupView';
    popupView.textContent = 'Popup View Details';
    popupView.setAttribute('data-variant-id', product.variants[0].id);

    const popupViewBtn = document.createElement('a');
    popupViewBtn.className = 'c-btn -normal -link has-icon icon-right getVariable';
    popupViewBtn.href = '/products/' + product.handle;
    popupViewBtn.target = '_blank';
    const btnText = document.createElement('span');
    btnText.className = 'c-btn__txt';
    btnText.textContent = 'View Details';
    const btnIcon = document.createElement('span');
    btnIcon.className = 'c-btn__ico';
    const icon = document.createElementNS(SVG_NS, 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('width', '24');
    icon.setAttribute('height', '24');
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M5 12h14M12 5l7 7-7 7');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    icon.appendChild(path);
    btnIcon.appendChild(icon);
    popupViewBtn.appendChild(btnText);
    popupViewBtn.appendChild(btnIcon);
    detailsDiv.appendChild(popupView);
    detailsDiv.appendChild(popupViewBtn);
    card.appendChild(detailsDiv);

    const cartDiv = document.createElement('div');
    cartDiv.className = 'wc_coll_side';
    const priceDiv = document.createElement('div');
    priceDiv.className = 'c-wc-product-collection__price price';
    const strong = document.createElement('strong');
    strong.className = 'woo-price-label';
    const span1 = document.createElement('span');
    span1.className = 'starts-at';
    span1.textContent = 'Starts at';
    strong.appendChild(span1);
    const span2 = document.createElement('span');
    span2.className = 'woocommerce-Price-amount amount';
    span2.textContent = '$' + minPrice(product.variants.map(v => v.price)).toFixed(2);
    strong.appendChild(span2);
    priceDiv.appendChild(strong);

    const btnDiv = document.createElement('div');
    btnDiv.className = 'fco_btn_wrapper';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'addToCard fco_btn2 button';
    button.textContent = 'Add to Cart';
    button.setAttribute('data-variant-id', product.variants[0].id);
    button.setAttribute('data-product-handle', product.handle);
    const btnIcon2 = document.createElement('span');
    const icon2 = document.createElementNS(SVG_NS, 'svg');
    icon2.setAttribute('viewBox', '0 0 24 24');
    icon2.setAttribute('width', '24');
    icon2.setAttribute('height', '24');
    const path2 = document.createElementNS(SVG_NS, 'path');
    path2.setAttribute('d', 'M5 12h14M12 5l7 7-7 7');
    path2.setAttribute('fill', 'none');
    path2.setAttribute('stroke', 'currentColor');
    path2.setAttribute('stroke-width', '2');
    path2.setAttribute('stroke-linecap', 'round');
    path2.setAttribute('stroke-linejoin', 'round');
    icon2.appendChild(path2);
    btnIcon2.appendChild(icon2);
    button.appendChild(btnIcon2);
    btnDiv.appendChild(button);
    priceDiv.appendChild(btnDiv);
    cartDiv.appendChild(priceDiv);
    card.appendChild(cartDiv);

    container.appendChild(card);
  });

  paginationDiv = document.createElement('div');
  paginationDiv.className = 'page-opt center';
  container.appendChild(paginationDiv);

  renderPagination(products);
}

function renderPagination(products) {
  const totalPages = Math.ceil(products.length / perPage);

  if (window.currentPage > totalPages) {
    window.currentPage = 1;
    updateProducts(products);
    window.allProducts = products;
    const color = $('.filter-color input:checked').val();
    updateProductLinksByColor(color);
  }

  let paginationDiv = document.querySelector('.page-opt');
  if (!paginationDiv) {
    paginationDiv = document.createElement('div');
    paginationDiv.className = 'page-opt center';
    document.querySelector('.product-grid').after(paginationDiv);
  }
  paginationDiv.innerHTML = '';

  if (window.currentPage > 1) {
    const prevSpan = document.createElement("span");
    prevSpan.className = "prev";
    const prevLink = document.createElement("span");
    prevLink.textContent = "";
    prevLink.onclick = () => {
      window.currentPage = window.currentPage - 1;
      updateProducts(products);
      window.allProducts = products;
      const color = $('.filter-color input:checked').val();
      updateProductLinksByColor(color);
    };
    prevSpan.appendChild(prevLink);
    paginationDiv.appendChild(prevSpan);
  }

  for (let i = 1; i <= totalPages; i++) {
    const btn = document.createElement('span');
    btn.classList.add("page");
    btn.textContent = i;
    if (i === window.currentPage) btn.classList.add("current", "page");
    btn.onclick = () => {
      window.currentPage = i;
      updateProducts(products);
      window.allProducts = products;
    };
    paginationDiv.appendChild(btn);
  }

  if (window.currentPage < totalPages) {
    const nextSpan = document.createElement("span");
    nextSpan.className = "next";
    const nextLink = document.createElement("span");
    nextLink.onclick = () => {
      window.currentPage = window.currentPage + 1;
      updateProducts(products);
      window.allProducts = products;
      const color = $('.filter-color input:checked').val();
      updateProductLinksByColor(color);
    };
    nextLink.textContent = "";
    nextSpan.appendChild(nextLink);
    paginationDiv.appendChild(nextSpan);
  }
}

async function updateTypes(types) {
  if (!types || !types.length) return;

  const container = document.querySelector('.coll_colors');
  if (!container) return;
  container.innerHTML = '';

  types.forEach((type) => {
    const dataVal = (type?.split(' ')[0] || '').replace(/[^A-Za-z]/g, '');

    const label = document.createElement('label');
    label.className = 'custom-checkbox';

    const input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'type_term';
    input.className = 'style-filter';
    input.dataset.val = dataVal;
    input.value = type;

    const checkmark = document.createElement('span');
    checkmark.className = 'checkmark';

    const termColor = document.createElement('span');
    termColor.className = 'term-color single-color';
    const swatch = document.createElement('span');
    swatch.className = 'color-swatch';
    swatch.style.borderColor = '#f5f5dc';
    termColor.appendChild(swatch);

    const termLabel = document.createElement('span');
    termLabel.className = 'term-label';
    termLabel.textContent = ` ${type}`;

    label.appendChild(input);
    label.appendChild(checkmark);
    label.appendChild(termColor);
    label.appendChild(termLabel);
    container.appendChild(label);
  });

  // Hiding function call (after update)
  setTimeout(hideCollectionCheckboxes, 300);
}

function updateColorDropdown(select, selectedColor) {
  const opts = Array.from(select.options);
  const placeholder = opts.find(o => o.disabled || o.value === '' || /choose an option/i.test(o.textContent)) || null;

  opts.forEach(o => {
    o.hidden = false;
    o.disabled = false;
    o.style.display = '';
  });

  if (!selectedColor) {
    if (placeholder) select.value = placeholder.value || '';
    select.dispatchEvent(new Event('change', {
      bubbles: true
    }));
    return;
  }

  const match = opts.find(o => norm(o.textContent) === norm(selectedColor) || norm(o.value) === norm(selectedColor)
  );

  if (match) {
    select.value = match.value;
    opts.forEach(o => {
      if (o !== match && o !== placeholder) {
        o.hidden = true;
        o.disabled = true;
        o.style.display = 'none';
      }
    });
  } else {
    if (placeholder) select.value = placeholder.value || '';
  }

  select.dispatchEvent(new Event('change', {
    bubbles: true
  }));
}

function updateAllColorDropdowns() {
  const selectedColor = getSelectedColor();
  document.querySelectorAll(colorSelectSelector).forEach(sel => updateColorDropdown(sel, selectedColor));
}

const observer = new MutationObserver(muts => {
  let shouldApply = false;
  for (const m of muts) {
    for (const node of m.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.(colorSelectSelector) || node.querySelector?.(colorSelectSelector)) {
        shouldApply = true;
        break;
      }
    }
    if (shouldApply) break;
  }
  if (shouldApply) updateAllColorDropdowns();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('change', (e) => {
  const t = e.target;
  if (!t?.matches('.color-filter[type="checkbox"]')) return;
  const container = t.closest('.filter-group') || document;
  const group = container.querySelectorAll('.color-filter[type="checkbox"]');
  if (t.checked) group.forEach(cb => {
    if (cb !== t) cb.checked = false;
  });
  updateAllColorDropdowns();
});

document.addEventListener('DOMContentLoaded', updateAllColorDropdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-toggle").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const content = btn.nextElementSibling;

      btn.classList.toggle("active");
      content.classList.toggle("active");
    });
  });
});



  // filter cards

  document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);

  const selectedColor = urlParams.get('color');
  const selectedStyles = urlParams.getAll('style[]');
  const selectedConstructions = urlParams.getAll('construction[]');

  const cards = document.querySelectorAll('.collection-card');

  cards.forEach(card => {
    const cardColor = card.dataset.color?.trim();
    const cardStyle = card.dataset.style?.trim();
    const cardConstruction = card.dataset.construction?.trim();

    var showCard = true;

    // Check color
    if (selectedColor && selectedColor !== cardColor) {
      showCard = false;
    }

    // Check style
    if (selectedStyles.length > 0 && !selectedStyles.includes(cardStyle)) {
      showCard = false;
    }

    // Check construction
    if (selectedConstructions.length > 0 && !selectedConstructions.includes(cardConstruction)) {
      showCard = false;
    }

   card.style.display = showCard ? 'block' : 'none';

   // Show .no_coll if filters exist but no card matches
  const noCollDiv = document.querySelector('.no_coll');
  if (!showCard) {
    if (noCollDiv) noCollDiv.style.display = 'block';
  } else {
    if (noCollDiv) noCollDiv.style.display = 'none';
  }
    
  });

    
    
});

function applyFiltersToCards(params = {}) {
  const section = document.querySelector('.collection-grid');
  const cards = section.querySelectorAll('.collection-card');
  let matchCount = 0;

  cards.forEach(card => {
    const cardColor = card.dataset.color?.trim().toLowerCase();
    const cardStyle = card.dataset.style?.trim().toLowerCase();
    const cardConstruction = card.dataset.construction?.trim().toLowerCase();

    let showCard = true;

    if (params.color && params.color !== cardColor) {
      showCard = false;
    }

    if (params.styles?.length && !params.styles.includes(cardStyle)) {
      showCard = false;
    }

    if (params.constructions?.length && !params.constructions.includes(cardConstruction)) {
      showCard = false;
    }

    card.style.display = showCard ? 'block' : 'none';
    if (showCard) matchCount++;
  });

  if(matchCount == 0) {
      document.querySelector('.no_coll')?.remove();
      document.querySelector('.collection-grid').innerHTML = '<p class="no_coll">No products match your filters.</p>';
  }
}


document.querySelector('.custom-filter-reset')?.addEventListener('click', function (e) {
  e.preventDefault();

  // Reset all filters
  document.querySelectorAll('input[name="style[]"]:checked').forEach(cb => cb.checked = false);
  document.querySelectorAll('input[name="construction[]"]:checked').forEach(cb => cb.checked = false);
  document.querySelectorAll('input[name="color"]:checked').forEach(cb => cb.checked = false);
  document.querySelectorAll('.single-color.term-color').forEach(cb => cb.classList.remove('active'));
  document.querySelector('.no_coll')?.remove();
  document.querySelectorAll('.collection-card').forEach(card => card.style.display = 'block');

});


/*
document.querySelector('.custom-filter-reset')?.addEventListener('click', function (e) {
  e.preventDefault();

  // Reset all filters
  document.querySelectorAll('input[name="style[]"]:checked').forEach(cb => cb.checked = false);
  document.querySelectorAll('input[name="construction[]"]:checked').forEach(cb => cb.checked = false);

  const urlParams = new URLSearchParams();
  urlParams.append("sections", "collection-grid-ajax");

  const fetchURL = `${window.location.pathname}?${urlParams.toString()}`;

  fetch(fetchURL)
    .then(res => res.json())
    .then(data => {
      const html = data["collection-grid-ajax"];
      document.querySelector('.collection-grid').innerHTML = html;

      applyFiltersToCards({});
    })
    .catch(err => {
      console.error('Error fetching original collection:', err);
    });
});
*/


// Filter Collections
document.querySelector('.custom-filter-submit')?.addEventListener('click', function (e) {
  e.preventDefault();

  const colors = Array.from(document.querySelectorAll('input[name="color"]:checked'))
    .map(cb => cb.value.toLowerCase());
  console.log("colors selected:", colors);
  
  const styles = Array.from(document.querySelectorAll('input[name="style[]"]:checked'))
  .map(cb => cb.value.toLowerCase());
  console.log("styles selected:", styles);
  
  const constructions = Array.from(document.querySelectorAll('input[name="construction[]"]:checked'))
  .map(cb => cb.value.toLowerCase());
  console.log("constructions selected:", constructions);

  const cards = document.querySelectorAll('.collection-card');

  // Hide all cards
  cards.forEach(card => { card.style.display = 'none'; });

  let filteredCards = Array.from(cards).filter(card => {
    const cardColors = card.dataset.color
      ? card.dataset.color
          .toLowerCase()
          .replace(/[\[\]"]/g, '') // remove brackets + quotes
          .split(',')
          .map(c => c.trim())
      : [];

    const cardStyle = card.dataset.style
      ? card.dataset.style
          .toLowerCase()
          .replace(/[\[\]"]/g, '') // remove brackets + quotes
          .split(',')
          .map(c => c.trim())
      : [];

    const cardConstruction = card.dataset.construction
      ? card.dataset.construction
          .toLowerCase()
          .replace(/[\[\]"]/g, '') // remove brackets + quotes
          .split(',')
          .map(c => c.trim())
      : [];

    let match = true;

    if (colors.length && !colors.some(color => cardColors.includes(color))) {
      match = false;
    }

    if (styles.length && !styles.some(style => cardStyle.includes(style))) {
      match = false;
    }

    if (constructions.length && !constructions.some(construction => cardConstruction.includes(construction))) {
      match = false;
    }

    return match;
  });

  if(filteredCards.length > 0) {
    // Show matched cards
    document.querySelector('.no_coll')?.remove();
    filteredCards.forEach(card => { card.style.display = 'block'; });
  } else{
    document.querySelector('.no_coll')?.remove();
    document.querySelector('.collection-grid').insertAdjacentHTML('beforeend', '<p class="no_coll">No collections found.</p>');
  }
});


/*
document.querySelector('.custom-filter-submit')?.addEventListener('click', function (e) {
  e.preventDefault();

  const color = document.querySelector('input[name="color"]:checked')?.value?.toLowerCase();
  console.log("Color Selected: " + color);
  const styles = Array.from(document.querySelectorAll('input[name="style[]"]:checked')).map(cb => cb.value.toLowerCase());
  const constructions = Array.from(document.querySelectorAll('input[name="construction[]"]:checked')).map(cb => cb.value.toLowerCase());

  const urlParams = new URLSearchParams();

  if (color) urlParams.append("color", color);
  styles.forEach(style => urlParams.append("style[]", style));
  constructions.forEach(con => urlParams.append("construction[]", con));
  urlParams.append("sections", "collection-grid-ajax");

  const fetchURL = `${window.location.pathname}?${urlParams.toString()}`;

  fetch(fetchURL)
    .then(res => res.json())
    .then(data => {
      if (data && data["collection-grid-ajax"] && data["collection-grid-ajax"].length > 0) {
        const html = data["collection-grid-ajax"];

      document.querySelector('.collection-grid').innerHTML = html;

      applyFiltersToCards({
        color,
        styles,
        constructions
      });
    } else {
      document.querySelector('.no_coll')?.remove();
      document.querySelector('.collection-grid').innerHTML = '<p class="no_coll">No products match your filters.</p>';
    }
    })
    .catch(err => {
      console.error('Error fetching filtered collections:', err);
    });
});
*/

document.querySelectorAll('.single-color.term-color').forEach(color => {
  color.addEventListener('click', function (e) {
    e.preventDefault();

    const inputEl = color.closest('label').querySelector('input');

    if (!inputEl) return;

    if (color.classList.contains('active')) {
      color.classList.remove('active');
      inputEl.checked = false;
      return;
    }

    // document.querySelectorAll('.single-color.term-color').forEach(cb => cb.classList.remove('active'));
    // document.querySelectorAll('input[name="color"]').forEach(input => input.checked = false);

    color.classList.add('active');
    inputEl.checked = true;
  });
});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-checkbox input[type="checkbox"]').forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        this.parentElement.classList.add('active');
      } else {
        this.parentElement.classList.remove('active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
  // window.addEventListener('load', function () {
  //      var megaMenu = jQuery('.globo-formbuilder').detach();

  //     // Append original to first target
  //     jQuery('.free-kitchen-design-container .form-box').append(megaMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-contact-form"] && !Shopify.designMode) return;
  try {
    
  // window.addEventListener('load', function () {
  //      var megaMenu = jQuery('.globo-formbuilder').detach();

  //     // Append original to first target
  //     jQuery('.free-kitchen-design-container .form-box').append(megaMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    

window.addEventListener('load', function () {
    if (typeof jQuery === 'undefined') {
      console.error('jQuery is still not loaded!');
      return;
    }

    jQuery('.mega-menu').css("display", "flex");

    var megaMenu = jQuery('.mega-menu').detach();

    // Append original to first target
    jQuery('.header__submenu').append(megaMenu);

    // Clone and append to second target
    jQuery('#Details-menu-drawer-menu-item-1 .menu-drawer__inner-submenu ul li').append(megaMenu.clone());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
    function updateProgress_collection(swiper) {
      const current = swiper.realIndex + 1;
      const total = parseInt(document.querySelector(".testimonail_carousel .total-slides").textContent);
      document.querySelector(".testimonail_carousel .current-slide").textContent = current;
    }

    document.addEventListener("DOMContentLoaded", function () {
      const swiper = new Swiper(".testimonail_carousel", {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: ".testimonail_carousel .swiper-button-next",
          prevEl: ".testimonail_carousel .swiper-button-prev"
        },
        on: {
          slideChange: function () {
            updateProgress_collection(this);
          },
          init: function () {
            updateProgress_collection(this);
          }
        }
      });
    });

  } catch(e) { console.error(e); }
})();
})();
